import React from 'react';

export default function CheckBoxField({
    fieldData,
    currentStateValue,
    onChangeHandler,
    controlStateData,
    changeOrder,
    fieldsColumn,
    size = 'small',
    beforeIcon = null,
    afterIcon = null,
    reverse = false,
    alignToTop = false,
    shouldLabelIncludeAsteriskIfRequired = true,
}) {
    const fieldDataId = fieldData.id ?? fieldData.name;
    const isEmptyState = !currentStateValue;
    const isFormSubmit = controlStateData && controlStateData.isSubmit;
    const isRequiredError = fieldData.isRequired && isEmptyState;

    const getErrorMessage = () => {
        if (!isFormSubmit) { return null; }
        if (isRequiredError) { return fieldData.requiredError; }
        return null;
    };

    const getFlexDirectionClassName = () => {
        if (fieldsColumn) return 'flex-column';
        return reverse ? 'flex-row-reverse' : 'flex-row';
    };

    return (
        <>
            <div className={`from__checkboxWrapper ${reverse ? 'form__checkboxWrapper--reverse' : ''} d-flex ${alignToTop ? 'align-items-start' : 'align-items-center'} ${getFlexDirectionClassName()}`}>
                <input
                    id={fieldDataId}
                    name={fieldData.name}
                    type="checkbox"
                    onChange={onChangeHandler}
                    className={`form__checkbox ${size === 'small' ? 'form__checkbox--small' : ''} ${changeOrder ? 'order-2' : ''}`}
                    checked={currentStateValue}
                />
                <label
                    htmlFor={fieldDataId}
                    className={`form__label--checkbox ${fieldsColumn ? 'my-3' : 'my-0'} ${changeOrder ? 'order-1' : ''}`}
                >
                    <span className="form__label-title-container">
                        {beforeIcon}
                        <span
                            className={`form__labelTitle ${isRequiredError && isFormSubmit ? 'form__labelTitle--error' : ''}`}
                            dangerouslySetInnerHTML={{ __html: `${fieldData.isRequired && shouldLabelIncludeAsteriskIfRequired ? '<span class="form__asterisk--required"> *</span>' : ''}${fieldData.commentText}` }}
                        />
                        {fieldData.notice && (
                            <span className="form__asterisk mx-1">**</span>
                        )}
                        {afterIcon}
                    </span>
                </label>
            </div>
            {fieldData.requiredError && (
                <span className={`form__message form__message--error ${isRequiredError && isFormSubmit ? 'form__message--visible' : ''}`}>
                    {getErrorMessage() ?? <>&nbsp;</>}
                </span>
            )}
        </>
    );
}
